module.exports = __webpack_public_path__ + "img/check-green-icon.92ecd481.svg";